var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Cropper from 'react-cropper';

import './ImageEditCropdata.scss';

var ImageEditCropdata = (_temp2 = _class = function (_Component) {
    _inherits(ImageEditCropdata, _Component);

    function ImageEditCropdata() {
        var _temp, _this, _ret;

        _classCallCheck(this, ImageEditCropdata);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { cropdata: {} }, _this.onReady = function () {
            var cropdata = _this.props.cropdata;

            _this.refs.cropper.setData(cropdata);
        }, _this.onCrop = function () {
            var image = _this.refs.cropper.getImageData();
            var canvas = _this.refs.cropper.getCanvasData();
            var crop = _this.refs.cropper.getCropBoxData();
            var data = _this.refs.cropper.getData();

            _this.setState({
                //            cropdata: data
            });

            if (_this.props.onCrop) {
                _this.props.onCrop(data);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ImageEditCropdata.prototype.render = function render() {
        var media = this.props.media;
        var imageUrl = media.imageUrl;


        return React.createElement(Cropper, {
            ref: 'cropper',
            src: imageUrl,
            className: 'edit__cropdata',
            viewMode: 1,
            scalable: false,
            checkCrossOrigin: false,
            guides: false,
            ready: this.onReady,
            crop: this.onCrop });
    };

    return ImageEditCropdata;
}(Component), _class.defaultProps = {
    cropdata: {}
}, _temp2);


export default ImageEditCropdata;